import {
   Button, Dialog,
   DialogActions,
   DialogContent,
   DialogTitle,
   MenuItem,
   Select,
   TextField,
   Typography
} from '@material-ui/core';
import React from 'react';

const SharedConstants = require('../../../../../shared/sharedConstants');

const MultiLineTextField = require('../commonControls.jsx.js').MultiLineTextField;

export function BracketSubmitDialog(props){
   return(
      <Dialog open={props.open}>
         <DialogTitle>Submit µPub to Bracket</DialogTitle>
         <DialogContent>
            <TextField
               multiline={true}
               label="Title"
               fullWidth
               value={props.selectedCardTitle}
               onChange={props.onTitleChanged}
            />
            <hr/>
            <Typography gutterBottom>Bracket Category</Typography>
            <Select fullWidth value={props.category} onChange={props.categoryOnChange}>
               <MenuItem value={SharedConstants.BracketCategory.TopLeftBracket.id}>{SharedConstants.BracketCategory.TopLeftBracket.name}</MenuItem>
               <MenuItem value={SharedConstants.BracketCategory.BottomLeftBracket.id}>{SharedConstants.BracketCategory.BottomLeftBracket.name}</MenuItem>
               <MenuItem value={SharedConstants.BracketCategory.TopRightBracket.id}>{SharedConstants.BracketCategory.TopRightBracket.name}</MenuItem>
               <MenuItem value={SharedConstants.BracketCategory.BottomRightBracket.id}>{SharedConstants.BracketCategory.BottomRightBracket.name}</MenuItem>
            </Select>
            <hr/>
            <MultiLineTextField data={props.selectedCardReason} label="Justification for Adding"
                                onChange={props.onSelectedCardReasonChanged} maxLength='1000' rows={3}/>
         </DialogContent>
         <DialogActions>
            <Button
               disabled={props.selectedCardReason.trim().length === 0 ||  props.selectedCardTitle.trim().length === 0}
               onClick={props.onSubmit}
            >
               Submit
            </Button>
            <Button onClick={props.onCancel}>Cancel</Button>
         </DialogActions>
      </Dialog>
   )
}
